import React from 'react';
import { OutputChartContainer } from '../charts';
import ChartTab from './ChartTab';

interface OutputTabProps {
  machineSerialNo?: string;
  lineId?: string; // Line ID for line-level aggregated data
  shifts?: string[];
  syncGroup?: string;
  activeSubTab?: 'shift' | 'day' | 'week';
  onActiveSubTabChange?: (tab: 'shift' | 'day' | 'week') => void;
}

const OutputTab: React.FC<OutputTabProps> = ({ 
  machineSerialNo, 
  lineId,
  shifts, 
  syncGroup,
  activeSubTab,
  onActiveSubTabChange
}) => {
  return (
    <ChartTab>
      <OutputChartContainer 
        machineSerialNo={machineSerialNo}
        lineId={lineId}
        shifts={shifts}
        syncGroup={syncGroup}
        activeSubTab={activeSubTab}
        onActiveSubTabChange={onActiveSubTabChange}
      />
    </ChartTab>
  );
};

export default OutputTab;
